module.exports = __webpack_public_path__ + "static/cent-front-3998012de6b41ebf3f83cb14a64a54b0.png";